import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'
import {FiAirplay, FiMapPin} from '../../assets/icons/vander'

import { jobData } from '../../data/job'


export default function PageJobs() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">All Jobs & Vacancies</h4>
                          <p className="text-muted mb-0">All vacancy and jobs are here,</p>
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link href="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link href="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Jobs</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
        <div className="container">
            <div className="row align-items-end mb-4 pb-2">
                <div className="col-lg-9 col-md-8">
                    <div className="section-title">
                        <h4 className="title mb-4">Latest Job or Vacancy list</h4>
                        <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                    </div>
                </div>

                <div className="col-lg-3 col-md-4 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="form custom-form">
                        <div className="mb-0">
                            <label className="form-label">Types of jobs :</label>
                            <select className="form-select mt-2" aria-label="Default select example">
                                <option selected>All Jobs</option>
                                <option>Full Time</option>
                                <option>Part Time</option>
                                <option>Remote</option>
                                <option>Work From Home</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {jobData.map((item,index)=>{
                    return(
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="card border-0 bg-light rounded shadow">
                                <div className="card-body p-4">
                                    <span className="badge rounded-pill bg-primary float-md-end mb-3 mb-sm-0">{item.jobType}</span>
                                    <h5>{item.title}</h5>
                                    <div className="mt-3">
                                        <span className="text-muted d-block"><FiAirplay className="align-middle text-primary h6 mb-0"/> <Link to="https://1.envato.market/leaping" target="_blank" className="text-muted">{item.name}</Link></span>
                                        <span className="text-muted d-block"><FiMapPin className="align-middle text-primary h6 mb-0"/> {item.country}</span>
                                    </div>
                                    
                                    <div className="mt-3">
                                        <Link to={`/page-job-detail/${item.id}`} className="btn btn-primary">View Details</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>

        <div className="container mt-100 mt-60">
            <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
                <div className="row align-items-center">
                    <div className="col-sm-7">
                        <div className="text-sm-start">
                            <h3 className="text-white title-dark mb-0">Let's get connected and start finding your dream job</h3>
                        </div>
                    </div>

                    <div className="col-sm-5 mt-4 mt-sm-0">
                        <div className="text-sm-end">
                            <Link to="#" className="btn btn-outline-primary">Create free account</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer/>

    </>
  )
}
